<template>
  <div class="alert-banner" v-if="false">
    <div class="alert-content">
      <span class="alert-message">
        We are restricting <b>Two Factor Authentication</b> from 15th of Sept.
        Please ensure you have updated your settings accordingly.
      </span>
      <button class="more-info-button" @click="showMoreInfo">
        Read More
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex/dist/vuex.common.js";

export default {
  data() {
    return {
      showBanner: false
    };
  },
  methods: {
    showMoreInfo() {
      window.open(
        "https://scribehow.com/shared/Set_Up_Two-Factor_Authentication_on_Localhost__6WYmYTAvRqSehcmjwgXCng"
      );
    },
    closeBanner() {
      this.showBanner = false;
    }
  },
  computed: {
    ...mapGetters({
      getUser: "user/getUser"
    }),
    alertModel() {
      if (this.getUser.is2fa) {
        return false;
      } else {
        return true;
      }
    }
  }
};
</script>

<style scoped>
.alert-banner {
  background: var(--danger-bg);
  color: var(--danger);
  padding: 10px;
  border: 1px solid var(--danger);
  box-shadow: var(--shadow-sm);
  border-radius: var(--radius-md);
  margin: 5px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: var(--fs-sm);
}

.alert-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.alert-message {
  flex: 1;
  margin-right: 20px;
}

.more-info-button {
  background-color: transparent;
  color: var(--accent-600);
  border: none;
  border-radius: var(--radius-sm);
  cursor: pointer;
  margin-right: 10px;
  font-size: var(--fs-sm);
}

.close-button {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: var(--danger);
}
</style>
